export const STORE_CURRENT_ANSWER_IS_CORRECT = 'STORE_CURRENT_ANSWER_IS_CORRECT';
export const STORE_CURRENT_ANSWER_IS_INCORRECT = 'STORE_CURRENT_ANSWER_IS_INCORRECT';
export const STORE_CURRENT_ANSWER_IS_IGNORED = 'STORE_CURRENT_ANSWER_IS_IGNORED';
